import React from "react";
import { NativeStackScreenProps } from "@react-navigation/native-stack";
import { RootStackParamList } from "../navigator";
import { MessagesModal } from "../Components";
import HelpModal from "../Components/Modals/HelpModal";

type Props = NativeStackScreenProps<RootStackParamList, "Help">;

const HelpScreen: React.FC<Props> = ({ navigation }) => {
  return <HelpModal onClose={() => navigation.goBack()} />;
};

export default HelpScreen;
